<template>
  <!-- begin login -->
  <div class="login login-with-news-feed">
    <!-- begin news-feed -->
    <div class="news-feed">
      <div class="news-image" style="background-image: url(/assets/image/login-bg-11.jpg)"></div>
      <div class="news-caption">
        <h4 class="caption-title">
          <b>电子商城</b>管理后台系统
        </h4>
      </div>
    </div>
    <!-- end news-feed -->
    <!-- begin right-content -->
    <div class="right-content">
      <!-- begin login-header -->
      <div class="login-header">
        <div class="brand">
          <span class="logo"></span>
          <b>电子商城</b> 欢迎回来
          <small>{{ title }}</small>
        </div>
        <div class="icon">
          <i class="fa fa-sign-in"></i>
        </div>
      </div>
      <!-- end login-header -->
      <!-- begin login-content -->
      <div class="login-content">
        <LoginForm @on-success-valid="handleSubmit"></LoginForm>
      </div>
      <!-- end login-content -->
    </div>
    <!-- end right-container -->
  </div>
  <!-- end login -->
</template>

<script>
import PageOptions from "@/config/PageOptions.vue";
import LoginForm from "./login-form";
import { mapActions } from "vuex";
import config from "@/config";
export default {
  components: {
    LoginForm
  },
  created() {
    PageOptions.pageEmpty = true;
    document.body.className = "bg-white";
  },
  beforeRouteLeave(to, from, next) {
    PageOptions.pageEmpty = false;
    document.body.className = "";
    next();
  },
  data() {
    return {
      title: config.title,
      formdata: {
        email: "",
        password: ""
      }
    };
  },
  methods: {
    ...mapActions(["handleLogin"]),

    handleSubmit({ userName, password }) {
      this.handleLogin({ userName, password })
        .then(res => {
          this.$router.push({
            path: "/home/dashboard"
          });
        })
        .catch(error => {
          this.$Message.error("登录失败:" + error);
        });
    }
  }
};
</script>
